import axiosInstance from "../../axiosInstance";

// const base = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
// const BASE_URL = `${base}/students`;

const BASE_URL = '/elearning/students';

// ✅ Get danh sách học viên (có phân trang và lọc nếu cần)
export const getAllStudents = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}`, { params });
    return response.data;
  } catch (error) {
    console.error("Lỗi khi tải danh sách học viên:", error);
    throw error;
  }
};

/** Thống kê nhanh (cùng query params lọc như getAllStudents, không cần page/size) */
export const getStudentStats = async (params = {}) => {
  const response = await axiosInstance.get(`${BASE_URL}/stats`, { params });
  return response.data;
};

/** Xuất CSV học viên (cùng params lọc như getAllStudents, ví dụ no_class=true) */
export const exportStudentsCSV = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/export`, {
    params,
    responseType: "blob",
  });
  return res.data;
};



// ✅ Get thông tin 1 học viên
export const getStudentById = async (id) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Lỗi khi lấy thông tin học viên:", error);
    throw error;
  }
};

// ✅ Thêm học viên
export const createStudent = async (studentData) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}`, studentData);
    return response.data;
  } catch (error) {
    console.error("Lỗi khi thêm học viên:", error);
    throw error;
  }
};

// ✅ Cập nhật học viên
export const updateStudent = async (id, studentData) => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/${id}`, studentData);
    return response.data;
  } catch (error) {
    console.error("Lỗi khi cập nhật học viên:", error);
    throw error;
  }
};

// ✅ Xóa học viên
export const deleteStudent = async (studentId) => {
  try {
    const response = await axiosInstance.delete(`${BASE_URL}/${studentId}`);
    return response.data;
  } catch (error) {
    console.error("Lỗi khi xóa học viên:", error);
    throw new Error(error.response?.data?.message || "Không thể xóa học viên");
  }
};

// ✅ Lấy mã học viên tiếp theo (đã có sẵn)
export const getNextStudentCode = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/next-code`);
    return response.data.code;
  } catch (error) {
    console.error("Không lấy được mã học viên:", error);
    return '';
  }
};

/** Trường (đối tác) theo chi nhánh — dropdown import/form học viên */
export const getStudentMetaSchools = async (branchId) => {
  const res = await axiosInstance.get(`${BASE_URL}/meta/schools`, {
    params: { branch_id: branchId },
  });
  return res.data;
};

/** Lớp theo chi nhánh — dropdown import/form học viên */
export const getStudentMetaClasses = async ({ branch_id, unit, school_id } = {}) => {
  const params = {};
  if (branch_id) params.branch_id = branch_id;
  if (unit) params.unit = unit;
  if (school_id) params.school_id = school_id;
  const res = await axiosInstance.get(`${BASE_URL}/meta/classes`, { params });
  return res.data;
};

// ✅ Import học viên từ Excel/CSV
export const importStudents = async (file, classId = null) => {
  const formData = new FormData();
  formData.append("file", file);
  if (classId) formData.append("class_id", classId);
  const res = await axiosInstance.post(`${BASE_URL}/import`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60_000,
  });
  return res.data;
};
